import { CodeHighlight } from "../components/CodeHighlight";

const InstallationInstructionModal = ({ code }) => {
  const close = () => {
    document.querySelector("dialog").close();
  };

  return (
    <dialog>
      <div className={"modal"}>
        <div className={"modal__header"}>
          <div className={"modal__title"}>
            Configuration code is ready to use
          </div>
        </div>
        <div className={"modal__content"}>
          <div>
            You can embed webchat on any HTML page with configuration code.
          </div>
          <div>
            Just copy and paste it before closing <strong>&lt;/body&gt;</strong>{" "}
            tag on page.
          </div>
          <CodeHighlight code={code} />
        </div>

        <div className="modal__footer">
          <button type="button" className="btn" onClick={close}>
            Close
          </button>
        </div>
      </div>
    </dialog>
  );
};

export { InstallationInstructionModal };
